import { render, staticRenderFns } from "./CommentTooltip.vue?vue&type=template&id=742e61be&"
import script from "./CommentTooltip.vue?vue&type=script&lang=js&"
export * from "./CommentTooltip.vue?vue&type=script&lang=js&"
import style0 from "./CommentTooltip.vue?vue&type=style&index=0&id=742e61be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports